import React from 'react';
import { Redirect, type RouteContext } from '@atlassian/react-resource-router';

export const widgetsNextGenRedirect = ({ match }: RouteContext) => {
	const { projectKey } = match.params;
	const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/widget`;

	return <Redirect to={url} />;
};
